import React from 'react'
import styles from './About.module.css';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <section className={styles.about_area}>
        <h2><span>サービス</span>について</h2>
        <div className={styles.contents}>
            <p>
                「3営業日ランディングページ」というサービスは、クライアント様からの情報を受け取った後、わずか3営業日以内にランディングページ（LP）を制作し、ファイルとして納品するサービスでございます。<br className='sp' />このサービスは、迅速な対応を重視しており、クライアント様のマーケティング戦略に基づいた高品質なLPの提供を目指しております。<br className='sp' />納品されるのは、クライアント様が直ちに使用できるランディングページのファイルであり、タイトなスケジュールでの成果物提供に特化しております。
            </p>
            <div className={styles.box_wrapper}>
              <Card>
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      サービス概要
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{color: 'white'}}>
                      本サービスは、必要な情報を受け取った後、最短3営業日以内にLPを制作、納品するサービスです。
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button size="small" color="primary" as="a" href="https://cellnology.jp/3daylp/001/contact.php">
                    Contact
                  </Button>
                </CardActions>
              </Card>
              <Card>
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      迅速な対応
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{color: 'white'}}>
                      このサービスは迅速な対応を最優先事項とし、短期間での高品質な成果物の提供を実現いたします。
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button size="small" color="primary" as="a" href="https://cellnology.jp/3daylp/001/contact.php">
                    Contact
                  </Button>
                </CardActions>
              </Card>
              <Card>
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      マーケティング戦略と品質
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{color: 'white'}}>
                      私たちはクライアントのマーケティング戦略を深く理解し、それに基づいた高品質なランディングページの制作に努めます。
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button size="small" color="primary" as="a" href="https://cellnology.jp/3daylp/001/contact.php">
                    Contact
                  </Button>
                </CardActions>
              </Card>
              <Card>
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      即時利用可能
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{color: 'white'}}>
                      納品されるランディングページは即座に使用可能で、タイトなスケジュールでもクライアントのニーズに応じた成果物を提供いたします。
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button size="small" color="primary" as="a" href="https://cellnology.jp/3daylp/001/contact.php">
                    Contact
                  </Button>
                </CardActions>
              </Card>
            </div>
        </div> 
    </section>
  )
}

export default About